var map = {
	"./business.png": "7014",
	"./computer.png": "cabb",
	"./dance.png": "ffed",
	"./debate.png": "6f85",
	"./design.png": "54b4",
	"./gaming.png": "6ba0",
	"./history.png": "912b",
	"./photography.png": "1dad",
	"./psychology.png": "5c8d",
	"./reading.png": "07fa0",
	"./writing.png": "96c6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7e03";